export enum DayOfWeek {
  SUNDAY = "sunday",
  MONDAY = "monday",
  TUESDAY = "tuesday",
  WEDNESDAY = "wednesday",
  THURSDAY = "thursday",
  FRIDAY = "friday",
  SATURDAY = "saturday",
}

export enum FederalHoliday {
  NEW_YEARS_DAY = "New Years Day",
  MARTIN_LUTHER_KING_JR_DAY = "Martin Luther King Jr. Day",
  PRESIDENTS_DAY = "Presidents Day",
  MEMORIAL_DAY = "Memorial Day",
  JUNETEENTH = "Juneteenth",
  INDEPENDENCE_DAY = "Independence Day",
  LABOR_DAY = "Labor Day (USA)",
  VETERANS_DAY = "Veterans Day",
  THANKSGIVING_US = "Thanksgiving Day (USA)",
  CHRISTMAS_DAY = "Christmas Day",
  GOOD_FRIDAY = "Good Friday",
  VICTORIA_DAY = "Victoria Day",
  CANADA_DAY = "Canada Day",
  CIVIC_HOLIDAY = "Civic Holiday",
  LABOUR_DAY = "Labour Day (Canada)",
  TRUTH_AND_RECONCILIATION_DAY = "Truth and Reconciliation Day",
  THANKSGIVING_CA = "Thanksgiving Day (Canada)",
  REMEMBRANCE_DAY = "Remembrance Day",
  BOXING_DAY = "Boxing Day",
}

export interface HolidayOption {
  label: FederalHoliday;
  countryCodes: string[];
}
